import React from 'react';
import { CtaButton } from './CtaButton';
type SectionCtaProps = {
  label: string;
  note?: string;
  dark?: boolean;
};
export function SectionCta({
  label,
  note = 'Instant digital access · One-time payment of $27 USD',
  dark = false
}: SectionCtaProps) {
  return <div className="mx-auto mt-12 max-w-xl" data-id="element-58" data-mp="3ncjipogps1bd">
      <CtaButton label={label} data-id="element-59" data-mp="3nb8fpqv3exlb" />
      <p className={`mt-4 text-center text-sm font-medium ${dark ? 'text-white/70' : 'text-ink/60'}`} data-id="element-60" data-mp="3nemih07o58ta">{note}</p>
    </div>;
}